import { differenceInCalendarDays, format, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const conversationListTimestamp = (timestamp, now = new Date()) => {
  if (timestamp === null || timestamp === undefined || timestamp === '')
    return '';
  const numeric =
    typeof timestamp === 'number' || /^\d+(\.\d+)?$/.test(String(timestamp));
  const date =
    timestamp instanceof Date
      ? timestamp
      : new Date(numeric ? Number(timestamp) * 1000 : timestamp);
  if (!isValid(date)) return '';
  const days = differenceInCalendarDays(now, date);
  if (days === 0) return format(date, 'HH:mm');
  if (days === 1) return 'Ontem';
  if (days > 1 && days < 7) return format(date, 'EEEEEE', { locale: ptBR });
  return format(date, 'dd/MM/yyyy');
};
